/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Bottom_LeftInputs */

const en_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom Left`)
};

const fr_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas Gauche`)
};

const de_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unten links`)
};

const it_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In basso a sinistra`)
};

const ru_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижний левый угол`)
};

const es_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abajo a la izquierda`)
};

const zh_cn2_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左下角`)
};

const ja_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左下`)
};

const hi_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तली छोड़ें`)
};

const pt_pt2_input_position_bottom_left = /** @type {(inputs: Input_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canto inferior esquerdo`)
};

/**
* | output |
* | --- |
* | "Bottom Left" |
*
* @param {Input_Position_Bottom_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_bottom_left = /** @type {((inputs?: Input_Position_Bottom_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Bottom_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_bottom_left(inputs)
	if (locale === "de") return de_input_position_bottom_left(inputs)
	if (locale === "it") return it_input_position_bottom_left(inputs)
	if (locale === "ru") return ru_input_position_bottom_left(inputs)
	if (locale === "es") return es_input_position_bottom_left(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_bottom_left(inputs)
	if (locale === "ja") return ja_input_position_bottom_left(inputs)
	if (locale === "hi") return hi_input_position_bottom_left(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_bottom_left(inputs)
	return en_input_position_bottom_left(inputs)
});